import { buildMongoQueryMatcher, createAliasResolver, createMongoAbility, type ForcedSubject, type MongoAbility } from '@casl/ability';
import { $and, and } from '@ucast/mongo2js';
import type SubjectActions from 'resources/json/SubjectActions.json';

export type AppAction =
   | 'manage'
   | 'create'
   | 'read'
   | 'update'
   | 'delete'
   | 'write'
   | 'edit'
   | 'assign'
   | 'comment'
   | 'link'
   | 'run'
   | 'send'
   | 'sign'
   | 'review'
   | 'approve'
   | 'archive'
   | 'unreview'
   | 'unapprove'
   | 'unarchive'
   | 'reject'
   | 'rollforward'
   | 'requestevaluation'
   | 'resetpassword'
   | 'maintain';

export type AppSubjectType =
   | keyof typeof SubjectActions
   | 'all'
   | 'any'
   | 'approvalCenter'
   | 'businessactivity_taxonomyactivity'
   | 'fsliTotal'
   | 'ghgMethod'
   | 'importDefinition'
   | 'kpiTopicContext'
   | 'kpiFieldGroupRow'
   | 'kpiValueItem'
   | 'notification'
   | 'organisationResult'
   | 'risk'
   | 'riskMitigation'
   | 'riskMitigationControl'
   | 'riskMitigationTask'
   | 'stakeholder_organisation'
   | 'supplyChainQuestionnaireResponse'
   | 'taskComment';

export type AppSubject = AppSubjectType | ForcedSubject<AppSubjectType>;
export type AppAbility = MongoAbility<[AppAction, AppSubject]>;

const resolveAction = createAliasResolver({
   write: ['update', 'create'],
   edit: ['update'],
});

const conditionsMatcher = buildMongoQueryMatcher({ $and }, { and });

const ability = createMongoAbility<AppAbility>([], { resolveAction, conditionsMatcher });

export default ability;
